import { reactive } from 'vue'

export const confirmState = reactive({ open: false, title: '', message: '', confirmLabel: 'Confirmer', danger: false, resolve: null })

/**
 * Ouvre la boîte de confirmation globale (montée dans App.vue).
 * Renvoie une promesse résolue à true (confirmé) ou false (annulé).
 */
export function confirmDialog({ title, message = '', confirmLabel = 'Confirmer', danger = false }) {
  return new Promise((resolve) => {
    Object.assign(confirmState, { open: true, title, message, confirmLabel, danger, resolve })
  })
}

export function answerConfirm(value) {
  const resolve = confirmState.resolve
  confirmState.open = false
  confirmState.resolve = null
  if (resolve) resolve(value)
}
